<style>
    #card-element {
        height: 40px;
        padding: 10px 12px;
        width: 100%;
        color: #32325d;
        background-color: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    #card-element:focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    #card-element.invalid {
        border-color: #fa755a;
    }

    #card-element .StripeElement--invalid {
        border-color: #fa755a;
    }

    #card-element .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

</style>

<template>
    <form @submit.prevent="store()" v-if="visible">
        <div class="t_center" id="card-element"></div>
        <div class="row m-t-20">
            <div class="col-sm-12 clearfix">
                <a href="#" @click.default="closeForm" class="btn btn-white">{{ $t('cancel') }}</a>
                <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from '@/utils/helpers/notify'
    import { trans } from '@/utils/helpers/translation'
    import { addCreditCard } from '@/services/subscriptions'
    import { loadStripe } from '@stripe/stripe-js'

    export default {
        name: 'Form',
        props: [ 'visible' ],
        data () {
            return {
                isSaving: false,
                record: {
                    token: ''
                },
                token: '',
                cardElement: null,
                stripe: null,
                errors: []
            }
        },
        watch: {
            visible () {
                if (this.visible)
                    this.loadCreditCardForm()
            }
        },
        methods: {
            closeForm () {
                this.$emit('closeForm')
                this.isSaving = false
                this.token = ''
                this.record = {
                    token: ''
                }
                this.errors = []
            },
            async getToken () {
                const { token, error } = await this.stripe.createToken(this.cardElement)

                if (error)
                    console.error('Erro ao criar token:', error)

                return token
            },
            async loadCreditCardForm () {
                this.stripe = await loadStripe(process.env.STRIPE_API_KEY)
                const elements = this.stripe.elements()
                const style = {
                    base: {
                        iconColor: '#c4f0ff',
                        color: '#000',
                        fontWeight: 500,
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',
                        '::placeholder': {
                            color: '#87BBFD'
                        },
                        ':-webkit-autofill': {
                            color: '#fce883'
                        }
                    },
                    invalid: {
                        iconColor: '#FFC7EE',
                        color: '#FFC7EE'
                    }
                }
                this.cardElement = elements.create('card', {style, hidePostalCode: true})
                this.cardElement.mount('#card-element')
            },
            async store () {
                this.isSaving = true

                const token = await this.getToken()
                this.record.token = token
                addCreditCard(this.record)
                    .then(response => {
                        this.$emit('cardUpdated', response.data)
                        Notify.success(trans('_notifications.success'))
                        this.closeForm()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/billing/credit-card/Form.vue